'use client'

import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
    toId: string;
    offset?: number; // Custom margin offset
}

export default function ScrollToButton({ toId, offset = 100, ...props }: Props) {

    
    function scrollToElementById(elementId: string) {
        const element = document.getElementById(elementId);

        if (element) {
            // Get the element's top position relative to the document
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            // Scroll with a smooth behavior and apply the offset
            window.scrollTo({
                top: elementPosition - offset,
                behavior: 'smooth'
            });
        } else {
            console.error(`Element not found with id: ${elementId}`);
        }
    }

    return (
        <div {...props} onClick={() => scrollToElementById(toId)}>
            {props.children}
        </div>
    );
}
